<template>
  <div class="select-main-category-component"
       v-bind:class="{loaded: loaded}"
       data-dusk="select-main-category-component"
  >
    <a-select :disabled="disabled"
              placeholder="Selecteer..."
              :value="this.setValue"
              @change="onChange"
              style="width:100%"
    >
      <a-select-option v-for="(category, key) in categories"
                       :key="key" :value="category.id"
                       style="width:100%"
      >
        {{ category.name }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import categoryApi from "~/api/category"

export default {
  name: "SelectMainCategoryComponent",
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: Number,
      default: undefined,
      required: false
    }
  },
  data() {
    return {
      categories: [],
      loaded: false,
      setValue: this.value
    };
  },
  created() {
    this.initCategories();
  },
  computed: {},
  methods: {
    initCategories() {
      categoryApi.getCustomerCategories().then(response => {
        this.categories = response.data;
        this.loaded = true;
      });
    },
    onChange(category) {
      this.setValue = category;
      this.$emit('category-selected', category);
    }
  }
}
</script>

<style scoped>
</style>
